/**
 * Shipper HQ
 *
 * @copyright Copyright (c) 2026 Zowta Ltd (http://www.shipperhq.com)
 * Copyright, 2026, Zowta, LLC - US license
 */

import React from 'react'
import panelStyles from './MerchantResults.module.css'
import styles from './BrandsPanel.module.css'
import LogoTitleBoxing from 'assets/images/frontend/global/clients/client-titleboxing.svg'
import LogoSony from 'assets/images/frontend/global/clients/client-sony.svg'
import LogoToyota from 'assets/images/frontend/global/clients/client-toyota.svg'
import LogoKohler from 'assets/images/frontend/global/clients/client-kohler.svg'
import LogoGibson from 'assets/images/frontend/global/clients/client-gibson.svg'
import LogoViewSonic from 'assets/images/frontend/global/clients/client-viewsonic.svg'

const LOGOS = [
    { src: LogoTitleBoxing, alt: 'Title Boxing' },
    { src: LogoSony, alt: 'Sony' },
    { src: LogoToyota, alt: 'Toyota' },
    { src: LogoKohler, alt: 'Kohler' },
    { src: LogoGibson, alt: 'Gibson' },
    { src: LogoViewSonic, alt: 'ViewSonic' },
]

interface BrandsPanelProps {
    headline?: boolean
}

export const BrandsPanel: React.FC<BrandsPanelProps> = ({
    headline = false,
}) => {
    return (
        <div className={panelStyles.panel} data-testid="brands-panel">
            {headline && (
                <>
                    <h2 className={styles.headline}>
                        Your rates, your rules —<br />
                        exactly how you want them.
                    </h2>
                    <p className={styles.subheadline}>Let&rsquo;s jump in.</p>
                </>
            )}
            <p className={styles.trustedLine}>
                Trusted by 6,000+ merchants worldwide
            </p>
            <div className={styles.logoGrid}>
                {LOGOS.map((logo) => (
                    <img
                        key={logo.alt}
                        src={logo.src}
                        alt={logo.alt}
                        className={styles.logo}
                    />
                ))}
            </div>
        </div>
    )
}
